import { useWatch } from "react-hook-form";

const getNestedError = (errors, name) =>
    name?.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), errors);

const CharCounter = ({ name, control, maxLength }) => {
    const value = useWatch({ control, name });
    const count = typeof value === "string" ? value.length : 0;
    return (
        <span style={{ color: count > maxLength ? "var(--red)" : undefined, fontSize: "0.8rem", whiteSpace: "nowrap" }}>
            {count}/{maxLength}
        </span>
    );
};

const FormInputText = ({ name, label, register, type = "text", errors, disabled, placeholder = "Start typing", style, maxLength, control }) => {
    const fieldError = getNestedError(errors, name);
    const showFooter = fieldError?.message || maxLength != null;
    return (
        <div className="form-input" style={style}>
            <label>{label}</label>
            {type === "textarea"
                ? <textarea {...register(name)} type={type} style={{ height: "48px" }} placeholder={placeholder} disabled={disabled} />
                : <input {...register(name)} type={type} style={{ height: "48px" }} placeholder={placeholder} disabled={disabled} />}
            {showFooter && (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", paddingTop: ".4rem" }}>
                    <span style={{ color: "var(--red)", fontSize: "inherit" }}>
                        {fieldError?.message ?? ""}
                    </span>
                    {maxLength != null && <CharCounter name={name} control={control} maxLength={maxLength} />}
                </div>
            )}
        </div>
    );
};

export default FormInputText;